<div class="priority-row">
  <div class="priority-row-content">
    <ng-container *ngFor="let priority of priorities">
      <div class="priority-column">
        <div class="priority-stack-title" [style.background-color]="priority.colorCode"
             [style.border-bottom-color]="classShadowColorCode(priority.colorCode)">
          <h4>{{priority.title || ''}}</h4>
        </div>
        <div class="priority-stack-diamond"
             [style.background-color]="priority.colorCode"
             [style.border-color]="classShadowColorCode(priority.colorCode)"
        ></div>
      </div>
    </ng-container>
    <ng-container *ngIf="needsPlaceholderColumn">
      <div class="priority-column placeholder"
            (click)="onClickPurposeMissionBeliefs()">
        <div class="priority-stack-title"
             [style.background-color]="placeholderColor"
             [style.border-bottom-color]="placeholderColor">
          <h3 [style.color]="placeholderColor"></h3>
        </div>
        <div class="priority-stack-diamond"
             [style.background-color]="placeholderColor"
             [style.border-color]="placeholderColor"
        ></div>
      </div>
    </ng-container>
    <ng-container *ngIf="needsFillerPlaceholderColumns">
      <div class="priority-column placeholder"
           (click)="onClickPurposeMissionBeliefs()">
        <div class="priority-stack-title"
             [style.background-color]="placeholderColor"
             [style.border-bottom-color]="placeholderColor">
          <h3 [style.color]="placeholderColor"></h3>
        </div>
        <div class="priority-stack-diamond"
             [style.background-color]="placeholderColor"
             [style.border-color]="placeholderColor"
        ></div>
      </div>
    </ng-container>
    <ng-container *ngIf="needsFillerPlaceholderColumns">
      <div class="priority-column placeholder"
           (click)="onClickPurposeMissionBeliefs()">
        <div class="priority-stack-title"
             [style.background-color]="placeholderColor"
             [style.border-bottom-color]="placeholderColor">
          <h3 [style.color]="placeholderColor"></h3>
        </div>
        <div class="priority-stack-diamond"
             [style.background-color]="placeholderColor"
             [style.border-color]="placeholderColor"
        ></div>
      </div>
    </ng-container>
    <ng-container *ngIf="needsInvisiColumn">
      <div class="priority-column invisible">
        <div class="priority-stack-title" [style.background-color]="transparent"
             [style.border-bottom-color]="transparent">
          <h3 [style.color]="transparent"></h3>
        </div>
        <div class="priority-stack-diamond"
             [style.background-color]="transparent"
             [style.border-color]="transparent"
        ></div>
      </div>
    </ng-container>
    <ng-container *ngIf="needsSecondInvisiColumn">
      <div class="priority-column invisible">
        <div class="priority-stack-title" [style.background-color]="transparent"
             [style.border-bottom-color]="transparent">
          <h3 [style.color]="transparent"></h3>
        </div>
        <div class="priority-stack-diamond"
             [style.background-color]="transparent"
             [style.border-color]="transparent"
        ></div>
      </div>
    </ng-container>
  </div>
</div>
